import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";

declare module "axios" {
  export interface AxiosRequestConfig {
    skipGlobalLoader?: boolean;
    __showGlobalLoader?: boolean;
  }

  export interface InternalAxiosRequestConfig {
    skipGlobalLoader?: boolean;
    __showGlobalLoader?: boolean;
  }
}

type LoaderRequestConfig = InternalAxiosRequestConfig;

var currentRequestCount = 0;
let previouseRequestCount = 0;
let loader = document.getElementById("loader");

setInterval(() => {
  if (currentRequestCount !== previouseRequestCount && loader) {
    if (currentRequestCount > 0) loader.style.display = "block";
    else loader.style.display = "none";
    previouseRequestCount = currentRequestCount;
  }
}, 100);

const axiosClient = axios.create({
  baseURL: "https://api.indianyadavs.com/api",
  // baseURL: "http://localhost:8080/api",
  headers: { "Content-Type": "application/json" },
});

// Interceptors
axiosClient.interceptors.request.use(
  function (config: LoaderRequestConfig) {
    // Do something before request is sent
    if (!config.skipGlobalLoader) {
      currentRequestCount++;
      config.__showGlobalLoader = true;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    currentRequestCount--;
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  function (response: AxiosResponse) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const config = response.config as LoaderRequestConfig;
    if (config.__showGlobalLoader) currentRequestCount--;
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    const config = error?.config as LoaderRequestConfig | undefined;
    if (config?.__showGlobalLoader) currentRequestCount--;
    return Promise.reject(error);
  }
);

export default axiosClient;
